import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.API_KEYS)({
  component: ApiKeysLayout,
  staticData: {
    config: {
      breadcrumb: { title: "api_keys", to: APP_ROUTES_TO.API_KEYS },
      title: "api_keys",
      layout: { scroll: false },
    },
    permissions: [PERMISSIONS.AUTH_SVC_API_KEYS_VIEW],
  },
});

function ApiKeysLayout() {
  return <Outlet />;
}
